export default __webpack_public_path__ + "static/media/ddf-grafik_02.61b32507.png";